import { Group, Mesh } from 'three';
import { RootState } from '@react-three/fiber/dist/declarations/src/core/store';
import { threeStore } from '@modules/three/store/threeStore.ts';
import { ThreeRootState } from '@modules/three/common/BaseThreeScene';
import toggleVisibility from './toggleVisibility';

export default class Jaws extends Group {
  private lowerJawMesh: Mesh;
  private upperJawMesh: Mesh;
  protected rootState: RootState | ThreeRootState;
  private initialLowerJawPosition = [0, 0, 0];
  private initialUpperJawPosition = [0, 0, 0];
  public moveApartDistance = 0;

  constructor(lowerJaw: Mesh, upperJaw: Mesh) {
    super();
    this.lowerJawMesh = lowerJaw;
    this.upperJawMesh = upperJaw;
    this.rootState = threeStore.getState().rootState;
  }

  public moveApart(distance: number) {
    const [, initialUpperY] = this.initialUpperJawPosition;
    const [, initialLowerY] = this.initialLowerJawPosition;

    this.upperJawMesh.position.setY(initialUpperY + distance);
    this.upperJawMesh.children.forEach((child) => {
      child.position.y = initialUpperY + distance;
    });
    this.lowerJawMesh.position.setY(initialLowerY - distance);
    this.moveApartDistance = distance;
  }

  public toggleVisibility(jaw: 'lower' | 'upper', visible: boolean) {
    if (jaw === 'lower') {
      toggleVisibility(this.lowerJawMesh, visible);
    } else {
      toggleVisibility(this.upperJawMesh, visible);
    }
  }
}
